
// en.js
export default {
  hello: 'Hello',
  welcome: 'Welcome to our website'
};